// Saving files from the browser, and the CSV text two report pages share.

// A cell that starts with = + - @ (or a tab / carriage return) is read as a formula by Excel and
// Sheets. Jira text is typed by people, so such a cell gets a leading apostrophe and stays text.
const FORMULA_START = /^[=+\-@\t\r]/;

export function csvCell(value: unknown): string {
  let text = value === null || value === undefined ? '' : String(value);
  if (FORMULA_START.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

/** Excel-friendly CSV: UTF-8 byte order mark, CRLF line ends, every cell quoted. */
export function toCsv(header: string[], rows: unknown[][]): string {
  const line = (cells: unknown[]) => cells.map(csvCell).join(',');
  return '﻿' + [line(header), ...rows.map(line)].join('\r\n');
}

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function saveCsv(csv: string, filename: string): void {
  saveBlob(new Blob([csv], { type: 'text/csv;charset=utf-8' }), filename);
}
